import metaModel from "~/shared/src/utilities/metaModel";
import {
    ContainerLayoutStructure,
    FormFieldLayoutStructureAndDataBinding,
    FormLayoutStructure
} from "~/shared/src/utilities/modules/form";

function getContainerPaths( layoutCache: { [ layoutElementId : number ] : any }, layoutStructure: FormLayoutStructure ): { [ id: number ]: string } {
    const retVal: { [ id: number ]: string } = {};

    const walker = ( current: FormLayoutStructure|ContainerLayoutStructure|FormFieldLayoutStructureAndDataBinding, path: string = '' ) => {
        let pathPart = '';
        if ( current.type === 'CONTAINER' && layoutCache[ current.layoutElementId ]?.messages?.title ) {
            pathPart = layoutCache[ current.layoutElementId ]?.messages?.title + '/';
        }
        if ( current.type === 'FORM' || current.type === 'CONTAINER' ) {
            for ( const child of current.children ) {
                path += walker( child as ContainerLayoutStructure, pathPart );
            }
        }
        else {
            retVal[ current.layoutElementId ] = path;
        }
        return path;
    }

    walker( layoutStructure );

    return retVal;
}

/**
 *
 * @param {string} dataContext
 * @param {number[]} [itemIdsToInclude]           If set the itemIds to be included in export
 * @param {number[]} [referenceIdsToInclude]      If set the referenceIds to be included in export
 * @param {boolean} [excludeDeleted]
 */
export const getFormTestTemplate = ( schema: Schema, layoutCache: { [ layoutElementId : number ] : any }, layoutStructure?: FormLayoutStructure ) : string => {
    let retVal : string = '';

    const containerPaths = layoutStructure ? getContainerPaths( layoutCache, layoutStructure ) : {};

    for ( const elementId in layoutCache ) {
        const element = layoutCache[ elementId ];
        if ( element?.type ) {
            let messageCatalogKey: string = '';
            let alternateLabel: string = element.label ?? '';
            if ( element.messages?.label || element.messages?.title ) {
                messageCatalogKey = element.messages.label ?? element.messages.title;
            }
            else if ( element.propertySetId ) {
                const pset = metaModel[ schema ].getPropertySet( element.propertySetId );
                if ( pset ) {
                    messageCatalogKey = pset.uuid + ':TypeName';
                    alternateLabel = alternateLabel || pset.label;
                }
            }
            else if ( element.referenceSetId && element.referenceDirection ) {
                const rset = metaModel[ schema ].getReferenceSet( element.referenceSetId );
                if ( rset ) {
                    const itemType = metaModel[ schema ].getItemType( rset[ element.referenceDirection === 'DestToSrc' ? 'srcItemTypeId' : 'destItemTypeId' ] );
                    messageCatalogKey = itemType?.uuid + ':TypeName';
                    alternateLabel = ( alternateLabel || itemType?.label ) ?? '';
                }
            }

            let keyPath = '',
                path = '';

            if ( containerPaths[ elementId ] ) {
                keyPath = containerPaths[ elementId ];
                path = keyPath.split( '/' ).map( part => __( part ) ).join( '/' );
            }

            if ( messageCatalogKey && messageCatalogKey !== __( messageCatalogKey ) ) {
                retVal += `// ${path}${ __( messageCatalogKey ) }\n`
                retVal += `await getFormFieldValueByLabel( page, '${keyPath}${ messageCatalogKey }' );\n`
            }
            else if ( alternateLabel ) {
                retVal += `// ${path}${ alternateLabel }\n`
                retVal += `await getFormFieldValueByLabel( page, '${keyPath}${ alternateLabel }' );\n`
            }

        }
    }

    return retVal;
};

/**
 *
 * @param {TreeNodeData} treeNodeData
 */
export const getTreeTestTemplate = ( treeNodeData:  TreeNodeData ) : string => {
    let retVal : string = '';

    const walker = ( treeNode: TreeNodeData, labelPath: string = '', alternativePath : string = '' ) => {
        labelPath += `${treeNode.labelKey ?? treeNode.label}/`;
        alternativePath += `${treeNode.label}/`;
        retVal += `// ${alternativePath}\nawait getTreeNodeByLabelPath( page, '${labelPath}' );\n`
        if ( treeNode.children ) {
            for ( const childNode of treeNode.children ) {
                walker( childNode, labelPath, alternativePath );
            }
        }

    }

    if ( treeNodeData.children?.length ) {
        walker( treeNodeData.children[ 0 ] );
    }

    return retVal;
};